// extracted by mini-css-extract-plugin
export var label = "_h8-2";
export var slideContainer = "_h8-0";
export var slider = "_h8-1";